// Woocommerce scripts
/* global ajax_object */
/* global FWP */
/* global intlTelInput */

$(() => {
  /*const $body = $('body');
const isWoocommercePage = $body.hasClass('woocommerce-page');
const isCheckoutPage = $body.hasClass('woocommerce-checkout');
const isCartPage = $body.hasClass('woocommerce-cart');*/
  const $woocommerce = $('.woocommerce');
  let tooltipClose;
  // -/+ buttons for a product amount input.
  $woocommerce.on(
    'click',
    '.js-add-to-cart-plus, .js-add-to-cart-minus',
    (event) => {
      let $this = $(event.currentTarget);

      // Get current quantity values.
      let $qty = $this
        .closest('.js-cart-quantity')
        .find('input[type="number"].qty');
      let $miniCart = $qty.closest('.js-mini-cart-inner');
      let $tooltip = $miniCart.length
        ? $miniCart.find('.js-min-qty-tooltip')
        : $this.closest('.js-cart-quantity').find('.js-min-qty-tooltip');

      let val = parseFloat($qty.val());
      let max = $qty.attr('max') ? parseFloat($qty.attr('max')) : 9999;
      let min = $qty.attr('min') ? parseFloat($qty.attr('min')) : 0;
      let step = $qty.attr('step') ? parseFloat($qty.attr('step')) : 1;

      clearTimeout(tooltipClose);

      tooltipClose = setTimeout(() => {
        if ($tooltip.length) $tooltip.fadeOut();
      }, 3000);

      // Change the value if plus or minus.
      if ($this.is('.js-add-to-cart-plus')) {
        if (max && max <= val) {
          $qty.val(max);
        } else {
          $qty.val(val + step);
        }

        if ($tooltip.length) {
          $tooltip.fadeOut();
        }
      } else {
        if (min && min >= val) {
          $qty.val(min);
        } else if (val > 0.5) {
          $qty.val(val - step);
        }

        if ($tooltip.length) {
          if ($tooltip.data('min') >= $qty.val()) {
            $tooltip.fadeIn();
          }
        }
      }

      if ($miniCart.length && $qty.val() < min) {
        return;
      }

      // Dynamic pricing selector
      checkPricingRules(parseInt($qty.val()));

      $qty.trigger('input').trigger('change');

      if ($miniCart.length && typeof ajax_object !== 'undefined') {
        $miniCart.addClass('ajax-overlay ajax-overlay--active');
        $.post({
          url: ajax_object.ajax_url,
          data: {
            action: 'product_change_qty',
            nonce: ajax_object.nonce,
            cartItemKey: $qty.attr('name'),
            newQty: $qty.val(),
          },
          success: () => {
            $(document.body).trigger('wc_fragment_refresh');
            $miniCart.removeClass('ajax-overlay--active');
          },
          error: (error) => {
            console.log('$.ajax.error()');
            console.log(error);
            $miniCart.removeClass('ajax-overlay--active');
          },
        });
      }

      $(document).find('button[name="update_cart"]').trigger('click');
    }
  );

  // Check manual product qty change
  $woocommerce.on('change', 'input[name="quantity"].qty', (event) => {
    let $this = $(event.currentTarget);

    // Prevent input less than min value
    if (
      $this.prop('min') &&
      parseInt($this.val()) < parseInt($this.prop('min'))
    ) {
      $this.val($this.prop('min'));
    }

    // Update clone field
    $(document).find('input[name="quantity_clone"]').val($this.val());

    // Dynamic pricing selector
    checkPricingRules(parseInt($this.val()));

    // Update per unit inputs
    let $perUnit = $this.closest('.product').find('input.js-per-unit');

    if ($perUnit.length) {
      $perUnit.each((i, el) => {
        if ($(el).data('step')) {
          let perUnitVal = $this.val() * $(el).data('step');
          $(el).val(perUnitVal.toFixed(1));
        }
      });
    }
  });

  $woocommerce.on('change', 'input[name="quantity_clone"].qty', (event) => {
    let $this = $(event.currentTarget);

    // Prevent input less than min value
    if (
      $this.prop('min') &&
      parseInt($this.val()) < parseInt($this.prop('min'))
    ) {
      $this.val($this.prop('min'));
    }

    // Update real field
    $(document)
      .find('input[name="quantity"]')
      .val($this.val())
      .trigger('change');
  });

  // Units toggle
  $woocommerce.on('click', '.js-unit-toggle', (event) => {
    event.preventDefault();
    event.stopPropagation();

    let $this = $(event.currentTarget);
    let $unitOpts = $this.closest('.product').find('.js-per-unit-parent');
    $this.toggleClass('is-active');
    $unitOpts.toggleClass('is-visible');
  });

  // Per m2 change
  let inputUnitTimeout;
  $woocommerce.on('input', 'input.js-per-unit', (event) => {
    event.preventDefault();
    event.stopPropagation();

    let $this = $(event.currentTarget);
    let unitVal = parseFloat($this.val());
    let plantsPerUnit = unitVal / $this.data('step');

    clearTimeout(inputUnitTimeout);

    inputUnitTimeout = setTimeout(() => {
      if ($this.val() === '' || $this.val() === 0) return;

      $this.val(Math.ceil($this.val()));

      $this
        .closest('.product')
        .find('input[name="quantity"].qty')
        .val(plantsPerUnit.toFixed(0))
        .trigger('change');
    }, 1000);
  });

  // If input left empty set default step value
  $woocommerce.on('focusout', 'input.js-per-unit', (event) => {
    event.preventDefault();
    event.stopPropagation();

    let $this = $(event.currentTarget);
    let step = $this.data('step');

    if ($this.val() === '' || $this.val() === 0) {
      $this.val(step).trigger('input');
    }
  });

  // Switching between m2 / running meters
  $woocommerce.on('change', 'input.js-running-toggle', (event) => {
    event.preventDefault();
    event.stopPropagation();

    let $this = $(event.currentTarget);
    $this.closest('.js-per-unit-parent').toggleClass('running-show');
  });

  // Cart page qty manual change
  $woocommerce.on('change', 'input[name^="cart"].qty', () => {
    $(document).find('button[name="update_cart"]').trigger('click');
  });

  // Set min value to the quantity as the default one.
  $(() => {
    let $qty = !$('body').hasClass('woocommerce-cart')
      ? $('form.cart').find('input[type="number"].qty')
      : null;
    if ($qty) {
      let min = $qty && $qty.attr('min') ? parseFloat($qty.attr('min')) : 1;
      $qty.val(min);
    }
  });

  // Attribute tooltip close
  $woocommerce.on('click', '.js-tooltip-attr', function () {
    $(this).fadeOut();
  });

  $woocommerce.on('click', '.variations select', function () {
    $(this).siblings('.tooltip').fadeOut();
  });

  // Attribute tooltip open + delay
  $(document)
    .find('.js-tooltip-attr')
    .each((i, el) => {
      let $this = $(el);
      let delay = $this.data('delay') ? parseInt($this.data('delay')) : 1000;
      $this.delay(delay).fadeIn();
    });

  // M2 plants calc
  $woocommerce.on('click', '.js-plant-m2-calc-activate', function () {
    $(this).removeClass('is-inactive');
  });

  $woocommerce.on('click', '.js-plant-m2-calc-apply', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const $m2Input = $(document).find('.is-active input.js-m2-calc');
    const $productQty = $('form.cart input[name="quantity"]');
    const $currentUnit = $(document).find(
      'input[name="plant_calc_unit"]:checked'
    );
    const $qtyUnits = $(document).find('.js-pq-unit');

    if ($m2Input.length && $productQty.length) {
      let m2Value = parseInt($m2Input.val());
      const perMeter = $m2Input.data('amount') || 1;

      if (m2Value > 0) {
        let total = m2Value * parseInt(perMeter);
        $productQty.val(total).trigger('change');
        $this.closest('.js-pp-modal').removeClass('open');
      }
    }

    if ($currentUnit.length && $qtyUnits.length) {
      $qtyUnits.removeClass('is-active');
      $qtyUnits.filter('.pa_' + $currentUnit.val()).addClass('is-active');
    }
  });

  // Select m/m2 calculator part
  $(document).on('change', 'input[name="plant_calc_unit"]', function () {
    const $this = $(this);
    const $calcs = $(document).find('.js-plant-m2-calc-part');
    const $calc = $('#' + $this.val());

    if ($calcs.length && $calc.length) {
      $calcs.removeClass('is-active');
      $calc.addClass('is-active');
    }
  });

  // Chat widget open
  $(document).on('click', 'a[href="#chatwidget"]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    window['watermelonWidget'].emit('open-widget');
    $('#sleak-buttonwrap').trigger('click');
  });

  // FacetWP Min/Max price range
  $(document).ready(function () {
    facetRangeApply();
  });

  // FacetWP sync radio & active sort status
  $(document).on('facetwp-loaded', function () {
    var activeSort =
      typeof FWP.extras.sort !== 'undefined' && FWP.extras.sort
        ? FWP.extras.sort
        : 'default';

    $('.facetwp-sort-radio-wrap').each(function () {
      var $container = $(this);
      $container.find('.sort-radio').removeClass('checked');
      $container
        .find('.sort-radio[data-value="' + activeSort + '"]')
        .addClass('checked');
    });
  });

  $(document).on('click', '.facetwp-sort-radio-wrap .sort-radio', function () {
    var $clickedElement = $(this);
    var clickedValue = $clickedElement.attr('data-value');

    // Prevent trigger if already active option
    if ($clickedElement.hasClass('checked')) {
      return;
    }
    FWP.extras.sort = clickedValue === 'default' ? '' : clickedValue;
    FWP.soft_refresh = true;
    FWP.autoload();
  });

  $(document).on('facetwp-loaded', function () {
    facetRangeApply();

    // Update counters
    const $reset = $(document).find('.js-filters-reset span');
    let selectedFiltersCount = 0;
    const exclusions = ['pagenav', 'sorten', 'blog_sorten'];
    if ($reset.length) {
      Object.entries(FWP.facets).forEach(([name, val]) => {
        if (!exclusions.includes(name) && val && val.length > 0) {
          selectedFiltersCount += val.length;
        }
      });

      let selectedFilters = selectedFiltersCount
        ? '(' + selectedFiltersCount + ')'
        : '';
      $reset.text(selectedFilters);
    }

    // Product counter
    const $apply = $(document).find('.js-filters-apply span');
    if ($apply.length) {
      if (
        FWP.settings.pager &&
        typeof FWP.settings.pager.total_rows !== 'undefined'
      ) {
        $apply.text(FWP.settings.pager.total_rows);
      } else {
        $apply.text('');
      }
    }

    // Hide empty facets
    $(document)
      .find('.filter_item')
      .each(function () {
        $(this).toggleClass(
          'd-none',
          $(this).find('.facetwp-facet').is(':empty')
        );
      });

    // Scroll top after filtering
    /*if (FWP.loaded) {
      $('html, body').animate(
        {
          scrollTop: $('.facetwp-template').offset().top - 150,
        },
        500
      );
    }*/
  });
  $(document).ready(function () {
    removeResponsiveTableClass();
  });
  $('body').on(
    'updated_wc_div update_checkout wc_fragment_refresh wc_fragments_refreshed',
    function () {
      removeResponsiveTableClass();

      // Add2cart remove added state
      setTimeout(() => {
        $(document)
          .find('.single_add_to_cart_button.added')
          .removeClass('added');
      }, 200);
    }
  );

  // Main document ready
  $(document).ready(function () {
    // Free gift product functionality
    $('#cart-free-product').on('change', function () {
      let checkbox = $(this),
        id = checkbox.data('id');

      let data = {
        action: 'wc_add_to_cart',
        product_id: id,
      };
      console.log(data);
      $.ajax({
        // you can also use $.post here
        url: ajax_object.ajax_url, // AJAX handler
        data: data,
        type: 'POST',
        beforeSend: function () {
          // button.text('Loading...'); // change the button text, you can also add a preloader image
        },
        success: function () {
          $(document.body).trigger('fkcart_update_side_cart');
          $(document.body).trigger('wc_fragment_refresh');
          $(document.body).trigger('added_to_cart');
          setTimeout(function () {
            checkbox.prop('disabled', false);
          }, 200);
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // For debugging, console log any errors. In production, do something different.
          console.log(xhr.status);
          console.log(thrownError);
        },
      });
    });

    // Load product comments
    $(document).on('click', '.js-load-product-reviews', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $this = $(this);
      const $commentsList = $('#comments .commentlist');
      const $modal = $('#modal-pp-reviews');
      if (!$modal.length) return;
      const $container = $modal.find('.js-pp-modal-main');
      if (!$container.length) return;

      // Comments already loaded to the modal
      if ($container.children().length) {
        $modal.addClass('open');
        return;
      }

      $.ajax({
        // you can also use $.post here
        url: ajax_object.ajax_url, // AJAX handler
        data: {
          action: 'wc_load_comments',
          product_id: $this.data('id'),
        },
        type: 'POST',
        beforeSend: function () {
          $commentsList.addClass('loading');
        },
        success: function (data) {
          if (data.html) {
            $container.html(data.html);
          }
          $modal.addClass('open');
          $commentsList.removeClass('loading');
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // For debugging, console log any errors. In production, do something different.
          console.log(xhr.status);
          console.log(thrownError);
        },
      });
    });

    // Coupon hide/show mobile
    $('.js-discount-toggle').on('click', function () {
      if ($(window).width() < 992) {
        $(this).siblings('#coupon_code, button').slideToggle();
      }
    });

    // Stock notifier trigger
    $(document).on('click', '.cwginstock-trigger', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this)
        .addClass('d-none')
        .siblings('.cwginstock-subscribe-form')
        .slideDown();
    });

    // Open variations dropdown
    $(document).on('click', '.cwginstock-continue', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(document).find('.js-variation-selector select').trigger('mousedown');
    });

    // Chat helper
    $(document).on('click', '.js-chat-question', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $chatInput = $('#yourQuestion');
      const $this = $(this);

      if ($chatInput && $this.text()) {
        $chatInput.val('').val($this.text());

        const $submit = $chatInput.siblings('[type="submit"]');
        if ($submit) {
          setTimeout(() => {
            $submit.trigger('click');
          }, 200);
        }
      }
    });

    // Check stock notification submit
    $(document).on(
      'input change',
      'input[name="cwgstock_name"], input[name="cwgstock_email"], input[name="cwg_iagree_checkbox_input"]',
      function () {
        const $form = $(this).closest('.cwginstock-subscribe-form');
        checkStockNotifierFields($form);
      }
    );

    function checkStockNotifierFields($form) {
      if ($form == undefined) {
        return false;
      }
      const $name = $form.find('input[name="cwgstock_name"]');
      const $email = $form.find('input[name="cwgstock_email"]');
      const $agree = $form.find('input[name="cwg_iagree_checkbox_input"]');
      const $submit = $form.find('input[name="cwgstock_submit"]');
      let state = false;

      if ($name.length && $name.val()) {
        state = true;
      }

      if ($email.length && $email.val()) {
        state = true;
      } else if ($email.length && !$email.val()) {
        state = false;
      }

      if ($agree.length && $agree.is(':checked')) {
        state = true;
      } else if ($agree.length && !$agree.is(':checked')) {
        state = false;
      }

      if (state) {
        $submit.removeAttr('disabled');
      } else {
        $submit.attr('disabled', 'disabled');
      }
    }

    // Dynamic pricing product discount (Change price)
    $(document).on('quick_view_pro:open', function () {
      renderDynamicPrices();
    });

    // Remove quick view modal after closed
    $(document).on('quick_view_pro:close', function () {
      $(document).find('.wc-quick-view-modal').remove();
    });

    if ($(document.body).hasClass('single-product')) {
      renderDynamicPrices();

      $('input[name="quantity"].qty').trigger('change');
    }

    /*  Product page slider  */
    let productSliderArgs = {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    let $productSlider = $(document).find('.js-website-product-slider');
    let $parentSlider = $(document).find('.website-product-slider--parent');

    // Simple product page
    if ($productSlider.length === 1 && $parentSlider.length) {
      $parentSlider.addClass('is-visible').slick(productSliderArgs);
      productNavsSlider($parentSlider);
    }

    // Variable product page
    $(document).on(
      'show_variation',
      'form.variations_form',
      function (event, variation) {
        let $discount_options = $(document).find('.website_pricing_item');
        let variation_id = variation.variation_id.toString();

        if ($discount_options.length && variation.variation_id) {
          $discount_options.each(function (i, el) {
            let variations = $(el).data('variations')
              ? $(el).data('variations').toString()
              : '';
            // Hide/show items
            $(el).toggleClass(
              'd-block',
              variations.indexOf(variation_id) !== -1
            );
          });
        }

        // Hide stock notifier form
        $(document).find('.cwginstock-subscribe-form').hide();
        $(document).find('.cwginstock-trigger').removeClass('d-none');

        // Running meters apply value per variation
        let runningMeters = variation?.running_meters;
        if (runningMeters) {
          let newStep = 1 / runningMeters;
          const $modalInput = $(
            '#aantal-per-strekkende-meter input.js-m2-calc'
          );
          const $modalValue = $(
            '#aantal-per-strekkende-meter .js-plant-m2-value'
          );

          $('.js-per-unit[name="aantal-per-strekkende-meter"]')
            .val(newStep.toFixed(2))
            .data('step', newStep.toFixed(2));

          if ($modalInput.length) {
            $modalInput.attr('data-amount', runningMeters);
            $modalInput.data('amount', runningMeters);
            $modalInput.trigger('input');
          }

          if ($modalValue.length) {
            $modalValue.text(runningMeters);
          }

          // Apply current quantity to new meters
          $('input[name="quantity"]').trigger('change');
        }

        // Select variation radio
        if (variation.attributes) {
          $.each(variation.attributes, function (key, value) {
            let $activeParent = $(document).find(
              '.js-variation-radio-selector[data-attr="' + key + '"]'
            );
            let $activeChild = $activeParent.find(
              '[data-value="' + value + '"]'
            );

            if ($activeParent.length) {
              $activeParent.find('li').removeClass('selected');
            }

            if ($activeChild.length) {
              $activeChild.addClass('selected');
            }
          });
        }

        if ($productSlider.length) {
          // Show proper variation gallery
          $productSlider.each((i, el) => {
            const $el = $(el);
            if ($el.data('variation') === variation.variation_id) {
              $el.addClass('is-visible');
              setTimeout(() => {
                productNavsSlider($el);
              }, 200);
            } else {
              $(el).removeClass('is-visible');
              if ($(el).hasClass('slick-initialized')) {
                $(el).slick('unslick');
              }
            }
          });

          // Init current variation slider
          $productSlider
            .filter('.is-visible:not(.slick-initialized)')
            .slick(productSliderArgs);
        }
      }
    );

    // Update variation price (custom place)
    $(document).on('found_variation', function (event, variation) {
      let template = wp.template('custom-price-template');
      let $container = $('.woocommerce-variation-custom-price');

      $container.html(
        template({
          variation: variation,
        })
      );
    });

    // Reset variation data
    $(document).on('reset_data', 'form.variations_form', function () {
      // Hide variation sliders & show main
      if ($productSlider.length) {
        $productSlider.each((i, el) => {
          if ($(el).hasClass('slick-initialized')) {
            $(el).removeClass('is-visible').slick('unslick');
          }
        });
      }

      if ($parentSlider.length) {
        $parentSlider.addClass('is-visible').slick(productSliderArgs);
        productNavsSlider($parentSlider);
      }

      // Clear the price if the user deselects the variation
      $('.woocommerce-variation-custom-price').html('');

      // Reset variation radio
      $('.website-radio').removeClass('selected');
    });

    // Create and append slider navigation
    function productNavsSlider($slider) {
      let $navsContainer = $('.website-product-navs');
      $navsContainer.empty();

      if ($slider.length && $slider.hasClass('slick-initialized')) {
        let $images = $slider.find('.website-slide-item__image');
        if ($images.length > 1) {
          $images.each(function (i, el) {
            if ($(el).data('thumb')) {
              let $navItem = $('<div></div>')
                .css('background-image', 'url(' + $(el).data('thumb') + ')')
                .addClass('website-product-nav')
                .attr('data-slide', i);
              if (i === 0) $navItem.addClass('is-active');
              $navsContainer.append($navItem);
            }
          });
        }
      }

      setTimeout(function () {
        $slider.closest('.ajax-overlay').removeClass('ajax-overlay--active');
      }, 2000);
    }

    // Control slick
    $(document).on('click', '.website-product-nav', function () {
      $(this).addClass('is-active').siblings().removeClass('is-active');
      $(document)
        .find('.js-website-product-slider.slick-initialized')
        .slick('slickGoTo', $(this).data('slide'));
    });

    // Update navigation
    $(document)
      .find('.js-website-product-slider')
      .on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        let $navs = $(document).find('.website-product-nav');
        if ($navs.length) {
          $navs.removeClass('is-active');
          $navs
            .filter('[data-slide="' + nextSlide + '"]')
            .addClass('is-active');
        }
      });

    // Go to specific tab
    if ($(document.location.hash).length && $('#checkoutStepsContent').length) {
      $(document.location.hash).tab('show');
    }

    // Product gallery destroy slick slider
    $('.iconic-woothumbs-images').on('init', function (event, slick) {
      setTimeout(function () {
        slick.unslick();
      }, 300);
    });

    if ($('body').hasClass('woocommerce-checkout')) {
      $('#checkoutSteps').on('click', 'a.nav-tab-link', function (event) {
        event.preventDefault();
        $(this).tab('show');
      });

      $('#checkoutSteps a.nav-tab-link').on('shown.bs.tab', function (event) {
        $(event.target).removeClass('passed');

        // set 'passed' except #tab-payment - last tab
        if (event.relatedTarget.id !== 'tab-payment') {
          $(event.relatedTarget).addClass('passed');
        }
      });
    }

    $(document).on('click', 'a.disabled', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    // Checkout process clone button
    $(document).on('click', '.js-checkout-toggle', function (e) {
      let targetTabId = $(this).data('target');

      if ($(targetTabId).length) {
        e.preventDefault();
        $(targetTabId).tab('show');
        $(this).blur();
      }
    });

    // Login toggle (switch to register)
    $(document).on('click', '.js-toggle-login', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(e.target).closest('.account').toggleClass('is-register-open');
    });

    // Validate account fields (custom email validation)
    if (
      typeof $.validator !== 'undefined' &&
      typeof $.validator.addMethod === 'function'
    ) {
      $.validator.addMethod(
        'strictEmail',
        function (value, element) {
          return (
            this.optional(element) ||
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)
          );
        },
        'Voer een geldig e-mailadres in.'
      );
    }

    // Login form validation
    let isAccount = $('body.woocommerce-account').length;
    let loginForm = $('form.login');
    if (isAccount && loginForm.length && typeof $.fn.validate !== 'undefined') {
      const loginValidator = loginForm.validate({
        rules: {
          username: {
            required: true,
            strictEmail: true,
          },
          password: {
            required: true,
            minlength: 6,
          },
        },
        messages: {
          username: {
            required: 'Voer uw e-mailadres in.',
            strictEmail: 'Voer een geldig e-mailadres in.',
          },
          password: {
            required: 'Wachtwoord is vereist.',
            minlength: 'Wachtwoord dient minstens 6 tekens lang te zijn',
          },
        },
      });

      // Validate on change
      $('#username').on('change', function () {
        loginValidator.element('#username');
      });
    }

    // Registration form validation
    if ($('form.register').length) {
      const registerValidator = $('form.register').validate({
        rules: {
          email: {
            required: true,
            strictEmail: true,
          },
        },
        messages: {
          email: {
            required: 'Voer uw e-mailadres in.',
            strictEmail: 'Voer een geldig e-mailadres in.',
          },
        },
      });

      // Validate on change
      $('#reg_email').on('change', function () {
        registerValidator.element('#reg_email');
      });
    }

    // Account: Load more orders

    $('.js-more-orders').on('click', function (e) {
      e.preventDefault();
      const $button = $(this);
      const nonce = $button.data('nonce');
      let page = parseInt($button.data('page'));
      let number = $button.data('number');
      const $overlay = $button.closest('.ajax-overlay');
      const $table = $(document).find('table.woocommerce-orders-table tbody');

      $.ajax({
        type: 'POST',
        url: ajax_object.ajax_url,
        data: {
          action: 'load_more_orders',
          page: page,
          per_page: parseInt(number),
          security: nonce,
        },
        beforeSend: function () {
          $overlay.addClass('ajax-overlay--active');
        },
        success: function (response) {
          if (response.success) {
            $table.append(response.data.html);
            page++;
            $button.attr('data-page', page).data('page', page);

            if (!response.data.has_more) {
              $button.remove();
            }
          }
        },
        complete: function () {
          $overlay.removeClass('ajax-overlay--active');
        },
      });
    });

    // Account: Load more Points

    $('.js-more-points').on('click', function (e) {
      e.preventDefault();
      const $button = $(this);
      const nonce = $button.data('nonce');
      let page = parseInt($button.data('page'));
      let number = $button.data('number');
      const $overlay = $button.closest('.ajax-overlay');
      const $list = $(document).find('#account-points-list');

      $.ajax({
        type: 'POST',
        url: ajax_object.ajax_url,
        data: {
          action: 'load_more_points',
          page: page,
          per_page: parseInt(number),
          security: nonce,
        },
        beforeSend: function () {
          $overlay.addClass('ajax-overlay--active');
        },
        success: function (response) {
          if (response.success) {
            $list.append(response.data.html);
            page++;
            $button.attr('data-page', page).data('page', page);

            if (!response.data.has_more) {
              $button.remove();
            }
          }
        },
        complete: function () {
          $overlay.removeClass('ajax-overlay--active');
        },
      });
    });

    // Single product add to cart
    /*$('.single_add_to_cart_button').on('click', function (e) {
      e.preventDefault();
      let $this = $(this),
        $form = $this.closest('form.cart'),
        id = $this.val(),
        product_qty = $form.find('input[name=quantity]').val() || 1,
        product_id = $form.find('input[name=product_id]').val() || id,
        variation_id = $form.find('input[name=variation_id]').val() || 0;
      let data = {
        action: 'website_wc_ajax_add_to_cart',
        product_id: product_id,
        product_sku: '',
        quantity: product_qty,
        variation_id: variation_id,
      };
      $.ajax({
        type: 'post',
        url: ajax_object.ajax_url,
        data: data,
        beforeSend: function () {
          $this.removeClass('added').addClass('loading');
        },
        complete: function () {
          $this.addClass('added').removeClass('loading');
          setTimeout(function () {
            $this.removeClass('added');
          }, 1000);
        },
        success: function (response) {
          if (response.error && response.product_url) {
            window.location = response.product_url;
            return '';
          } else {
            $('header .js-panel-toggle').trigger('click');
            $(document.body).trigger('added_to_cart', [
              response.fragments,
              response.cart_hash,
              $this,
            ]);
          }
        },
      });
    });*/

    // Mini-cart upsells ---------------------------------------------------------------------------------------------
    $(document).on('change', '.js-upsell-variation-pick', (e) => {
      let $this = $(e.target);
      let $parent = $this.closest('.fkcart--item');
      let variationPrices = $this.data('variations');
      if ($this.val() && $parent.length) {
        $parent.find('.fkcart-add-product-button').attr('data-id', $this.val());
        let $price = $parent.find('.fkcart-item-price');
        if ($price.length && variationPrices[$this.val()] !== undefined) {
          $price.html(variationPrices[$this.val()]);
        }
      }
    });

    // Checkout upsells ----------------------------------------------------------------------------------------------
    $(document).on('change', '.js-upsell-variations', (e) => {
      let $this = $(e.target);
      let $parent = $this.closest('.upsell_product');
      let variationPrices = $this.data('variations');

      if ($this.val() && $parent.length) {
        let $price = $parent.find('.js-upsell-variation-price');
        $parent.find('.js-upsell-add2cart').val($this.val());
        if ($price.length && variationPrices[$this.val()] !== undefined) {
          $price.html(variationPrices[$this.val()]);
        }
      }
    });

    // Upsell add to cart
    $(document).on('click', '.js-upsell-add2cart', (e) => {
      e.preventDefault();
      e.stopPropagation();
      let $this = $(e.target);
      let $holder = $this.closest('.ajax-overlay');
      if ($this.val()) {
        $.ajax({
          type: 'post',
          url: ajax_object.ajax_url,
          data: {
            action: 'website_wc_ajax_add_to_cart',
            product_id: parseInt($this.val()),
          },
          beforeSend: function () {
            $holder.addClass('ajax-overlay--active');
          },
          complete: function () {
            $holder.removeClass('ajax-overlay--active');
          },
          success: function (response) {
            if (!response.error) {
              setTimeout(() => {
                $(document.body).trigger('fkcart_update_side_cart');
                $(document.body).trigger('update_checkout');
              }, 400);
            }
          },
        });
      }
    });

    // Sticky add2cart button
    let $add2CartSticky = $('.js-sticky-add2cart');
    let $add2Cart = $('button[type="submit"].single_add_to_cart_button');
    let $footer = $('footer');
    let wh = $(window).height();
    $(window).on('scroll', function () {
      if (!$add2Cart.length || !$add2CartSticky.length) return false;

      let st = $(this).scrollTop();
      let condition =
        (st + wh <= $add2Cart.offset().top || st > $add2Cart.offset().top) &&
        $footer.offset().top - wh > st;
      $add2CartSticky.toggleClass('is-sticky', condition);
    });

    // Sticky Filters button
    let $filtersSticky = $('.js-filters-toggle');
    let $actionHolder = $('.webshop-filters-action');
    let $facetTemplate = $('.products.facetwp-template');
    $(window).on('scroll', function () {
      if (!$filtersSticky.length || !$actionHolder.length) return false;

      let st = $(this).scrollTop();
      let condition =
        (st + wh <= $actionHolder.offset().top ||
          st > $actionHolder.offset().top) &&
        $facetTemplate.offset().top + $facetTemplate.height() - wh / 5 > st;
      $filtersSticky.toggleClass('is-sticky', condition);
    });

    // Variation selector
    $(document).on('mousedown', '.js-variation-selector select', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).parent().toggleClass('is-open');
      $(this).siblings('ul').slideToggle('fast');
    });

    $(document).on('click', '.js-variation-selector ul li', function () {
      let $this = $(this);
      let $parent = $this.closest('.js-variation-selector');

      if ($this.data('value')) {
        $this.siblings('li').removeClass('selected');
        $this.addClass('selected');
        $parent.find('select').val($this.data('value')).trigger('change');
      }

      $parent.removeClass('is-open');
      $parent.find('ul').slideUp('fast');
    });

    // Close dropdown
    $(document).on('click', function (e) {
      const $openSelect = $('.js-variation-selector.is-open');
      if ($openSelect.length > 0) {
        if (
          !$openSelect.is(e.target) &&
          $openSelect.has(e.target).length === 0 &&
          !$(e.target).closest('.is-open').length
        ) {
          $openSelect.removeClass('is-open');
          $openSelect.find('ul').slideUp('fast');
        }
      }
    });

    // Variations radio selector
    $(document).on('click', '.js-variation-radio-selector li', function () {
      let $this = $(this);
      const $parent = $this.closest('.js-variation-radio-selector');
      const $select = $parent.find('select');

      if ($select.length && $this.data('value')) {
        $select.val($this.data('value')).trigger('change');
        $this.siblings('li').removeClass('selected');
      }
    });

    // Variation modal select (mobile)
    $(document).on('mousedown touchend', '.js-pp-modal-variation', function () {
      const $this = $(this);
      const $modal = $this.closest('.js-pp-modal');
      const $form = $(document).find('form.variations_form');
      const $vPrice = $this.find('.js-pp-modal-variation-price');
      const vID = $this.data('id');
      const slug = $this.data('attribute');

      const $currPrice = $modal.find('.js-pp-variant-price');
      const $currStock = $modal.find('.js-pp-variant-stock');

      if ($(window).width() < 768) {
        const $modalInner = $modal.find('.pp-modal__inner');
        const modalInnerHeight = $modalInner.innerHeight() ?? 0;
        const modalScrollHeight = $modalInner.prop('scrollHeight') ?? 0;
        let modalHeight = Math.max(modalInnerHeight, modalScrollHeight) + 20;
        $modal.css('height', modalHeight);
      }

      $this
        .closest('ul')
        .find('.js-pp-modal-variation')
        .removeClass('is-active');
      $this.addClass('is-active');

      $modal.data('selected', slug).attr('data-selected', slug);

      if ($form.length) {
        const vData = $form.data('product_variations');

        if (vData !== undefined && vData.length) {
          $.each(vData, function (i, v) {
            if (vID == v.variation_id) {
              $currPrice.html($vPrice.html());
              $currStock.html(v.availability_html);
            }
          });
        }
      }

      // Apply selected variation
      if ($(window).width() < 768) {
        const attribute = $modal.data('attribute');
        const selected = $modal.data('selected');

        if (attribute && selected) {
          $('#' + attribute)
            .val(selected)
            .trigger('change');
        }

        $modal.removeClass('open');
      }
    });

    // Apply chosen variation
    $(document).on(
      'mousedown touchend',
      '.js-pp-variation-apply',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        const $modal = $this.closest('.js-pp-modal');
        if (!$modal.length) return;
        const attribute = $modal.data('attribute');
        const selected = $modal.data('selected');

        if (attribute && selected) {
          $('#' + attribute)
            .val(selected)
            .trigger('change');
        }

        $modal.removeClass('open');
      }
    );

    // Reset variation modal
    $(document).on('mousedown touchend', '.js-pp-modal-variable', function () {
      const modalId = $(this).attr('href');
      if (modalId && $(modalId).length) {
        const attribute = $(modalId).data('attribute');
        if (attribute && $('#' + attribute).length) {
          const slug = $('#' + attribute).val();
          $(modalId).data('selected', slug).attr('data-selected', slug);
          $('.js-pp-modal-variation[data-attribute="' + slug + '"]').trigger(
            'mousedown'
          );
        }
      }
    });

    // Quantity selector (Dynamic pricing)
    $(document).on('click', '.js-set-quantity', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Set active
      $(document).find('.js-set-quantity').removeClass('active');
      $(this).addClass('active');

      // Set quantity
      if ($(this).data('quantity')) {
        $(document)
          .find('input[name="quantity"]')
          .val($(this).data('quantity'))
          .trigger('change');
      }
    });

    // Plant finder
    $(document).on('click', '.js-find-plants', function (e) {
      let $filters = $(document).find('.pf-dropdown-value');
      let filterValues = {};
      let $main = $(document).find('.plant-finder');
      let $primary = $(document).find('.js-pf-primary');
      let $secondary = $(document).find('.js-pf-secondary');

      // If button is disabled
      if ($(this).hasClass('disabled')) {
        e.preventDefault();
        e.stopPropagation();

        return;
      }

      $main.addClass('ajax-overlay--active');
      $filters.each(function () {
        if ($(this).data('attribute')) {
          filterValues[$(this).data('attribute')] = $(this).val();
        }
      });

      // AJAX Search
      $.post(ajax_object.ajax_url, {
        action: 'plants_finder',
        plant_filters: JSON.stringify(filterValues),
        primary_number: $primary.data('number'),
        secondary_number: $secondary.data('number'),
      }).done(function (response) {
        // Add primary products
        if (response.primary) {
          $primary.find('ul.products').html(response.primary);

          let primaryNum = $primary.find('li.product').length;
          showPrimaryNumbers(primaryNum);

          $primary.slideDown();

          $('html, body').animate(
            {
              scrollTop: $primary.offset().top,
            },
            500
          );
        } else {
          $primary.find('ul.products').html('');
          showPrimaryNumbers();
          $primary.slideUp();
        }

        // Add secondary products
        if (response.secondary) {
          $secondary.find('ul.products').html(response.secondary);
          $secondary.slideDown();
        } else {
          $secondary.find('ul.products').html('');
          $secondary.slideUp();
        }

        $main.removeClass('ajax-overlay--active');
      });
    });

    function showPrimaryNumbers(count = 0) {
      let $listSteps = $(document).find('.js-pf-primary ul.list-steps');
      if (!$listSteps.length) return false;

      if (count > 0) {
        $listSteps.attr('data-count', count);
        $listSteps.find('li').each(function (i, el) {
          if (i < count) {
            $(el).addClass('visible');
          }

          $(el).toggleClass('last-step', count === i + 1);
        });
        $listSteps.closest('.row').show();
      } else {
        $listSteps.find('li').removeClass('visible');
        $listSteps.closest('.row').hide();
      }
    }

    // Plant finder reset
    $(document).on('click', '.js-reset-plants', function () {
      let $this = $(this);
      let $filters = $(document).find('.pf-dropdown-value');

      // Disable search button
      $(document).find('.js-find-plants').addClass('disabled');

      $filters.each(function (i, el) {
        let $dropdownMenu = $(el).siblings('.pf-dropdown-menu');
        let defaultVal = $(el).data('default') ?? '';
        let $toggle = $(el).siblings('.pf-dropdown-toggle');

        $(el).val(defaultVal);

        if (defaultVal) {
          $dropdownMenu
            .find('button[data-value="' + defaultVal + '"]')
            .trigger('click');
        } else {
          $dropdownMenu.find('button').removeClass('active');
          $toggle.text('');
        }
      });

      $this.fadeOut();
    });

    // Plant finder attribute dropdown
    $('.pf-dropdown')
      .on('shown.bs.dropdown', function () {
        $('body').addClass('has-overlay');
      })
      .on('hidden.bs.dropdown', function () {
        $('body').removeClass('has-overlay');
      });

    // Select an item
    $('.pf-dropdown-item').on('click', function () {
      let $this = $(this);
      let $dropdown = $this.closest('.pf-dropdown');
      let $input = $dropdown.find('.pf-dropdown-value');
      let $toggle = $dropdown.find('.pf-dropdown-toggle');
      let applyValue = $this.data('value') ? $this.data('value') : '';

      // Set active
      $this.addClass('active').siblings().removeClass('active');

      if ($input.length) {
        $input.val(applyValue).trigger('change');

        checkRequiredFilters();
      }

      if ($toggle.length) {
        $toggle.text($this.text());
      }
    });

    // Change filter value
    $(document).on('change', '.pf-dropdown-value', function () {
      $(document).find('.js-reset-plants').fadeIn();
    });

    // Verify phone
    verifyPhone();
    // Plant m2 calc
    plantM2Calc();
  }); // end of Document ready

  /**
   * Show/hide the billing company field by the custom added checkbox.
   *
   * [1] - Important: The 'null' is added to the hidden billing Company field for to pass a required condition.
   *
   * @see The 'billing_company' & 'shipping_company' fields in the 'woocommerce_checkout_fields' hook in the woocommerce-checkout.php.
   */
  const $formCheckout = $('form.checkout');
  if ($formCheckout.length) {
    $formCheckout.on('change', '.js-toggle-company-fields', (event) => {
      const $this = $(event.currentTarget);
      const isChecked = $this.prop('checked');
      const $fields = $this.closest('.form-row').siblings('.js-hide-by-toggle');

      if ($fields.length) {
        $fields.toggleClass('d-none', !isChecked).show();
      }
    });
  }

  // Checkout trigger update on input change
  if ($formCheckout.length) {
    let inputNames = [
      'customer_email',
      'customer_subscribe',
      'billing_toggle',
      'shipping_vat_number',
    ];
    $formCheckout.on('change', (e) => {
      let $input = $(e.target);
      if (
        !!$input.attr('name') &&
        $.inArray($input.attr('name'), inputNames) !== -1
      ) {
        $(document.body).trigger('update_checkout');
        $(document.body).trigger('wc_fragment_refresh');
      }
    });

    $(document).on('click', '#place_order_clone', (e) => {
      e.preventDefault();
      e.stopPropagation();

      $formCheckout.find('#place_order').trigger('click');
    });
  }

  // Get shipping country onload
  let $shippingCountry = $formCheckout.find('#shipping_country');
  let shippingCountryValue = $shippingCountry.length
    ? $shippingCountry.val()
    : '';

  // Renew shipping methods on checkout updated
  $(document.body).on('updated_checkout updated_wc_div', function () {
    let $shippingMethods = $formCheckout.find('#checkout-shipping-methods');
    let $shippingCountryRecheck = $formCheckout.find('#shipping_country');
    let shippingCountryCurrent = $shippingCountryRecheck.val();
    let countryChanged = shippingCountryValue !== shippingCountryCurrent;

    if ($shippingMethods.length && typeof ajax_object !== 'undefined') {
      $(document.body).trigger('wc_fragment_refresh');
      $shippingMethods.addClass('ajax-overlay--active');

      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'website_wc_get_fragments',
          nonce: ajax_object.nonce,
          country: shippingCountryCurrent,
        },
        success: function (response) {
          if (!!response.data.html && countryChanged) {
            $shippingMethods.html(response.data.html);
            shippingCountryValue = shippingCountryCurrent;
          }
          $(document.body).trigger('fkcart_update_side_cart');
          $shippingMethods.removeClass('ajax-overlay--active');
        },
        error: function (e) {
          console.log(e);
          $shippingMethods.removeClass('ajax-overlay--active');
        },
      });
    }

    // Update order total (clone)
    let $orderTotal = $('#order_review').find('.order-total td strong');
    if ($orderTotal.length) {
      $(document).find('.js-cart-total').html($orderTotal.html());
    }

    // Update billing_email field
    let $customerEmail = $formCheckout.find('#customer_email');
    let $billingEmail = $formCheckout.find('#billing_email');
    if ($customerEmail.length && $billingEmail.length) {
      $billingEmail.val($customerEmail.val());
    }

    // Update customer subscribe field
    let $customerSubscribe = $formCheckout.find('#customer_subscribe');
    let $klaviyoSubscribe = $formCheckout.find('#kl_newsletter_checkbox');
    if ($customerSubscribe.length && $klaviyoSubscribe.length) {
      $klaviyoSubscribe.prop('checked', $customerSubscribe.prop('checked'));
    }

    // Hide/Show shipping company/vat fields
    toggleShippingCompany();
  });

  // Update mini cart
  $(document.body).on('fkcart_cart_open', function () {
    $(document.body).trigger('fkcart_update_side_cart');
  });

  // Review order update meta
  $(document).on(
    'change',
    'input.js-order-subscribe:not(.disabled)',
    function () {
      let $this = $(this);
      let $form = $this.closest('form');

      if ($form.length) {
        $.ajax({
          type: 'post',
          url: ajax_object.ajax_url,
          data: {
            action: 'website_wc_order_subscribe',
            order_id: parseInt($form.data('order')),
            subscribe: $this.is(':checked') ? 1 : 0,
          },
          beforeSend: function () {
            $form.addClass('ajax-overlay--active');
          },
          complete: function () {
            $form.removeClass('ajax-overlay--active');
          },
          success: function (response) {
            console.log(response);
          },
        });
      }
    }
  );
});

function checkPricingRules($qty) {
  let pricingRules = $(document).find('.js-set-quantity');
  pricingRules.removeClass('active');

  if (pricingRules.length && $qty) {
    pricingRules.each(function (index, el) {
      const $el = $(el);
      if (
        $qty === $el.data('quantity') ||
        ($el.data('to') &&
          $qty <= $el.data('to') &&
          $qty > $el.data('quantity')) ||
        ($el.data('to') === '' && $qty > $el.data('quantity'))
      ) {
        $el.addClass('active');

        // Mobile modal variation prices
        let vID = $el.parent('li').data('variations');
        let vOption = $(document).find(
          '.js-pp-modal-variation[data-id="' + vID + '"]'
        );
        let $price = $el.filter(':visible').find('.js-qty-price');

        if (vID && vOption.length) {
          vOption
            .find('.js-pp-modal-variation-price')
            .html($el.find('.js-qty-price').html());
        }

        if ($price.length) {
          $(document).find('.js-pp-variant-price').html($price.html());
        }
      }
    });
  }
}

function facetRangeApply($container) {
  let $facetContainer = $container ?? $('.facetwp-type-number_range');
  if ($facetContainer.length) {
    let $facetMin = $facetContainer.find('input.facetwp-number-min');
    let $facetMax = $facetContainer.find('input.facetwp-number-max');
    let $websiteMin = $facetContainer.find('[name="web_select_min"]');
    let $websiteMax = $facetContainer.find('[name="web_select_max"]');

    if ($facetMin.length && $facetMin.val()) {
      $websiteMin.val($facetMin.val());
    }
    if ($facetMax.length && $facetMax.val()) {
      $websiteMax.val($facetMax.val());
    }

    $('.js-facet-range').on('change', 'select', function () {
      let $this = $(this);

      if ($this.attr('name') === 'web_select_min') {
        $facetMin.val($this.val()).trigger('change');
        setOptionDisabled($websiteMax, $this.val());
      } else if ($this.attr('name') === 'web_select_max') {
        $facetMax.val($this.val()).trigger('change');
        setOptionDisabled($websiteMin, $this.val(), 'max');
      }

      $this.blur();
    });
  }
}

function setOptionDisabled($select, $value, $type = 'min') {
  if (typeof $select === undefined || !$select.length) return false;
  if (typeof $value === undefined) return false;

  $select.find('option').removeAttr('disabled');
  $select.find('option').each(function () {
    if (
      ($type === 'min' && parseInt($value) >= parseInt($(this).val())) ||
      ($type === 'max' && parseInt($value) <= parseInt($(this).val()))
    ) {
      $(this).attr('disabled', 'disabled');
    }
  });
}

function removeResponsiveTableClass() {
  $(document).find('table.shop_table').removeClass('shop_table_responsive');
}

// Dynamic pricing on Single page
/**
 * @param {number,string}  currentValue The number or string
 * @param {array} prices The array
 * @param {array} ranges The array
 */
function showCurrentPrice(currentValue, prices, ranges) {
  if (!Array.isArray(prices) && !Array.isArray(ranges)) {
    return;
  }
  $(prices).each(function () {
    $(this).not(':first-child').hide();
  });
  $(ranges).each(function (index, value) {
    if (
      (value.to &&
        value.from &&
        +currentValue >= +value.from &&
        +currentValue <= +value.to) ||
      (!value.to && value.from && +currentValue >= +value.from)
    ) {
      $(prices[0]).hide();
      $(prices[index]).show();
    }
  });
}

function getRanges(fromStr, toStr, prices) {
  if (typeof fromStr !== 'string' || typeof toStr !== 'string') return false;
  let from = fromStr.split(', ');
  let to = toStr.split(', ');
  let ranges = [];
  if (from && to && prices && prices.length > 0) {
    for (let i = 0; i < prices.length; i++) {
      ranges.push({ from: from[i], to: to[i] });
    }
  }
  return ranges;
}

function toggleShippingCompany() {
  let $billingToggle = $(document).find('input[name="billing_toggle"]:checked');
  let $shippingHolder = $(document).find('.woocommerce-shipping-fields');

  if ($billingToggle.length && $shippingHolder.length) {
    let state = $billingToggle.val() === 'use_billing_address';
    $shippingHolder.toggleClass('hide-company-fields', state);

    // Uncheck use shipping company fields
    if (state) {
      $shippingHolder
        .find('input[name="company-order-shipping-checkbox"]')
        .prop('checked', false);
      $shippingHolder.find('.js-hide-by-toggle').addClass('d-none');
    }
  }
}

function displayDynamicPrices(container, quantity) {
  if (container.length) {
    $(container).each(function (num, item) {
      let prices = $(item).find('.prices-item__piece');
      let from = $(item).data('from').toString();
      let to = $(item).data('to').toString();
      let ranges = getRanges(from, to, prices);
      let currentValue = quantity.val();
      showCurrentPrice(currentValue, prices, ranges);
      quantity.on('change', function () {
        let currentValue = $(this).val();
        showCurrentPrice(currentValue, prices, ranges);
      });
    });
  }
}

function renderDynamicPrices() {
  let simplePricesContainer = $(document).find(
    '.entry-summary p.price.simple-product-prices'
  );
  const stickyPricesContainer = $(document).find(
    '.add2cart_sticky p.price.simple-product-prices'
  );
  let quantity = $(document).find('.cart_quantity input[name="quantity"]');
  displayDynamicPrices(simplePricesContainer, quantity);
  displayDynamicPrices(stickyPricesContainer, quantity); // Sticky
  let customVariablePricesContainer = $(document).find(
    '.entry-summary p.price.variable-product-prices'
  );
  if (customVariablePricesContainer.length) {
    let $form = $(document).find('form.variations_form');
    $(document).on('change', 'form.variations_form', function () {
      let attrOption = $form.find('td.value select');
      let pricesDiv = $(document).find('.woocommerce-variation-custom-price');
      let customVariablePrices = $(customVariablePricesContainer).find(
        '.prices-item'
      );
      customVariablePrices.each(function () {
        if ($(this).data('slug') && $(this).data('slug') === attrOption.val()) {
          pricesDiv.html($(this).clone());
        }
      });
      let variablePricesContainer = pricesDiv.find('.prices-item');
      let quantityVariable = $form.find('input[name="quantity"]');
      displayDynamicPrices(variablePricesContainer, quantityVariable);
    });
    $form.find('.reset_variations').click(function () {
      $('.woocommerce-variation-custom-price').hide();
    });
    $form.find('td.value input[type="radio"]').click(function () {
      $('.woocommerce-variation-custom-price').show();
    });
  }
}

// Plant finder check required inputs
function checkRequiredFilters() {
  let $filters = $(document).find('.pf-dropdown-value');
  let $searchBtn = $(document).find('.js-find-plants');
  let validated = false;

  if ($filters.length && $searchBtn.length) {
    $filters.each(function (i, el) {
      if ($(el).attr('required') !== undefined) {
        if ($(el).val()) {
          validated = true;
        } else {
          validated = false;
          return false;
        }
      }
    });

    $searchBtn.toggleClass('disabled', !validated);
  }
}

// Sanitize (verify) phone number (checkout page)
function verifyPhone() {
  const $phoneInput = $('#shipping_phone, #billing_phone');
  if ($phoneInput.length) {
    const allowedCountries = ['nl', 'de', 'lu', 'dk', 'be', 'fr', 'ch', 'gb'];
    $phoneInput.each((i, el) => {
      let iti = intlTelInput(el, {
        onlyCountries: allowedCountries,
        countryOrder: allowedCountries,
        geoIpLookup: function (callback) {
          $.get(
            'https://ipinfo.io',
            function (success, failure) {
              if (failure != 'success') console.log(failure);
            },
            'jsonp'
          ).always(function (resp) {
            let countryCode =
              resp && resp.country ? resp.country.toLowerCase() : '';
            if (!allowedCountries.includes(countryCode)) countryCode = 'nl';
            callback(countryCode);
          });
        },
        initialCountry: 'auto',
        strictMode: true,
        countrySearch: false,
      });

      $(el).on('keyup change countrychange', function (e) {
        const itiNumber = iti.getNumber();
        if (itiNumber) {
          $(e.target).val(itiNumber);
        }
      });

      // Initial phone change
      $(el).trigger('change');
    });
  }
}

// Plant qty calc
function plantM2Calc() {
  $(document).on('input', 'input.js-m2-calc', function (e) {
    const $target = $(e.currentTarget);
    const val = parseFloat($target.val()) || 1;
    const res_id = $target.data('result');
    const $res = res_id ? $('#' + res_id) : false;
    const perMeter = $target.data('amount') || 1;

    if ($res && perMeter) {
      const total = Math.ceil(val * perMeter);
      $res.text(total);
    }
  });
}
